<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1>{{ editing ? 'Edit' : 'New' }} E-commerce User</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <form (ngSubmit)="save()">
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" class="form-control" id="name" name="name" [(ngModel)]="user.name" required>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" class="form-control" id="email" name="email" [(ngModel)]="user.email" required>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" class="form-control" id="password" name="password" [(ngModel)]="user.password">
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="is_loading">Save</button>
      </form>
    </div>
  </div>
</div>

<div class="col-auto">
	<a class="btn btn-secondary lift" (click)="show_add_user = true">
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5s-3.5 1.505-3.5 3.5zM19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z" fill="currentColor"/></svg>
		Agregar
	</a>
</div>

<app-modal [show]="show_add_user">
	<div class="card">
		<div class="card-body">
			<h3 class="card-title">Registrar Nuevo Usuario</h3>
			<form id="addUserForm" (submit)="addUser($event)" ngNativeValidate>
				<div class="row g-3">
					<div class="col-md-12">
						<label class="form-label">Nombre Completo</label>
						<input type="text" class="form-control" name="name" [(ngModel)]="new_user.name" required>
					</div>
					<div class="col-md-6">
						<label class="form-label">Usuario</label>
						<input type="text" class="form-control" name="user[username]" [(ngModel)]="new_user.username" required>
					</div>
					<div class="col-md-6">
						<label class="form-label">Contraseña</label>
						<input type="password" class="form-control" name="user[password]" [(ngModel)]="new_user.password">
					</div>
					<div class="col-md-6">
						<label class="form-label">Role</label>
						<select class="form-control" name="role_id" [(ngModel)]="new_user.role_id">
							<option value="">Sin Role</option>
							<option *ngFor="let role of roles" [value]="role.id">{{role.name}}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label class="form-label">Tipo</label>
						<select class="form-control" name="type" [(ngModel)]="new_ecommerce_user_info.type">
							<option value="ROLE_USER">Usuario</option>
							<option value="ROLE_ADMIN">Admin</option>
							<option value="ECOMMERCE_ADMIN">Ecommerce Admin</option>
						</select>
					</div>
					<div class="col-md-12">
						<button type="submit" class="btn btn-success" [disabled]="is_loading">Registrar Usuario</button>
						<button type="button" class="btn btn-secondary ms-2" (click)="show_add_user = false" [disabled]="is_loading">Cancelar</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</app-modal>